import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { publicAssets } from '@utils/url.utils';
import { CantFindYourDreamCarStyled } from '../CantFindYourDreamCarStyled';
export const CantFindYourDreamCarStyledOV = styled(CantFindYourDreamCarStyled)`
    border-radius: unset;

    .img {
        background-image: url('${publicAssets('/images/cantFindYourDreamCarOv_mob.png')}');

        @media (min-width: ${breakpoints.sm}px) {
            background-image: url('${publicAssets('/images/cantFindYourDreamCarOv.png')}');
        }
    }

    .content {
        .txt {
            @media (min-width: ${breakpoints.sm}px) {
                max-width: unset;
            }
        }
    }
`;
